import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

import * as config from './i18n.config';
import { safeGetItem } from './safe-storage';

export const supportedLngs = config.supportedLngs;
export const namespaces = config.namespaces;
export const defaultLocale = config.defaultLocale;
export const fallbackLanguage = config.fallbackLanguage;
export const defaultNamespace = config.defaultNamespace;

const allNamespaces = namespaces;

const supportedLngSet = new Set(supportedLngs);

// languages.json exposes `nb`, `no` and `nn` as separate pickable codes, but
// only `nb` (Bokmål) ships portal translations. Alias the generic/Nynorsk codes
// to `nb` so Norwegian users still get localized chrome instead of English.
const languageAliases: Record<string, string> = {
  no: 'nb',
  nn: 'nb',
};

export const normalizeLanguage = (language?: string | null) => {
  if (!language) return fallbackLanguage;
  const base = language.split(/[-_]/)[0]?.toLowerCase();
  const normalized = base ? (languageAliases[base] ?? base) : base;
  return normalized && supportedLngSet.has(normalized)
    ? normalized
    : fallbackLanguage;
};

const isBrowser = typeof window !== 'undefined';

const getPersistedLanguage = (): string | undefined => {
  const stored = safeGetItem('localStorage', 'i18nextLng');
  return stored ? normalizeLanguage(stored) : undefined;
};

if (!i18n.isInitialized) {
  i18n.use(HttpBackend);

  i18n
    .use(initReactI18next)
    .init({
      lng: getPersistedLanguage() ?? fallbackLanguage,
      fallbackLng: fallbackLanguage,
      defaultNS: defaultNamespace,
      ns: allNamespaces,
      supportedLngs,
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
      react: {
        useSuspense: false,
      },
      interpolation: {
        escapeValue: false,
      },
      load: 'currentOnly',
      initAsync: false,
    })
    .then(() => {
      if (isBrowser) {
        i18n.loadNamespaces(allNamespaces);
      }
    })
    .catch((error) => {
      console.error('Failed to initialise i18next', error);
    });
}

export default i18n;
